import styled from 'styled-components';
import { colors } from 'styleguide';

export default styled.div`
  display: flex;
  flex-grow: 1;
  min-height: 100%;
  min-width: 100%;
  border-radius: 2px;
  align-items: center;
  justify-content: center;
  border: 2px dashed ${colors('neutral', 5)};
  padding: 1em;
`;
